<script>
    // @ts-nocheck
    import { Typography, Button } from '$lib/components/UI'
    import ChatWidget from '$lib/components/UI/ChatWidget.svelte'
    import user from '$lib/stores/user'
    import dictionaries from '$lib/stores/dictionaries'
    import { API_URL } from '$lib/conf'
    import { ChevronFordware } from '$lib/components/Icons'
    import createChatStore from '$lib/stores/chat_store'
    import { fade } from 'svelte/transition'
    import { getDateObj, getRelTime, sleep, currencyFormatter } from '$lib/utils'
    import { onMount, getContext, createEventDispatcher } from 'svelte'
    import ChevronBackOutline from '$lib/components/Icons/ChevronBackOutline.svelte'
    export let claim = {}
    export let style = ''
    export let back = true
    const chatData = createChatStore({ defaultState: 'pending' })
    const token = user.getToken()
    const toast = getContext('toast')
    const dispatch = createEventDispatcher()
    function onBack() {
        dispatch('back')
    }

    function pushMessage({ detail: { message, store } }) {
        console.log(message)
        let { id, ..._msg } = message
        return user.fetch(`${API_URL}/claim/${claim.id}/messages`, {
            method: 'POST',
            body: JSON.stringify(message),
        })
            .then(async (req) => {
                if (req.ok) {
                    let msg = await req.json()
                    // store.delete(id)
                    store.updateMsg(id, {
                        ..._msg,
                        ...msg,
                        status: 'sync',
                        date: new Date(msg.date),
                    })
                } else {
                    console.log(await req.text())
                    store.delete(id)
                }
            })
            .catch(() => {
                store.delete(id)
                lostConnectionError()
                throw new Error('Error al enviar mensaje')
            })
    }

    function getMessages(since = null) {
        let query = since ? new URLSearchParams({ since }) : null
        return user.fetch(
            `${API_URL}/claim/${claim.id}/messages${query ? '?' + query.toString() : ''}`,
        )
            .then(async (req) => {
                if (req.ok) {
                    let data = await req.json()
                    return data
                } else {
                    throw new Error(`Error al traer mensajes.`)
                }
            })
            .catch((err) => {
                throw new Error(err)
            })
    }

    function closeClaim(since = null) {
        waiting = true
        return user.fetch(`${API_URL}/claim/${claim.id}/close`)
            .then(async (req) => {
                if (!req.ok) {
                    throw new Error(`Error al traer mensajes.`)
                } else {
                    sleep(2000).then(() => {
                        // window.location.reload()
                        user.navigate()
                    })
                    toast &&
                        toast.success(`Reclamo ${claim.id_reclamo} cerrado.`, {
                            duration: 2000,
                        })
                    onBack()
                }
            })
            .catch((err) => {
                throw new Error(err)
            })
            .finally(() => {
                waiting = false
            })
    }

    onMount(() => {
        const fetchMessages = getMessages().then((data) => {
            data.forEach((msg) => {
                try {
                    chatData.push(msg)
                } catch (_) {}
            })
        })
        // .catch(() => lostConnectionError())

        const refreshMessages = setInterval(() => {
            let since = chatData.lastDate.toISOString()
            getMessages(since).then((data) => {
                data.forEach((msg) => {
                    try {
                        chatData.push(msg)
                    } catch (_) {}
                })
            })
            // .catch(err => {
            //     lostConnectionError()
            // })
        }, 10000)
        refreshMessages
        return () => clearInterval(refreshMessages)
    })
    let waiting = false
    $: closed = claim?.closed || false
    export let showContext = false
    $: open_date = getDateObj(claim.creation_date)
    $: close_date = getDateObj(claim.fecha_finalizacion)
    const notification = () =>
        toast && toast.success('OK!')
</script>

<div
    style={`width: 100%; height: 100%; min-width: 500px; min-height: 700px; display: flex; ${style}`}
>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <ChatWidget
        title={`${claim.asunto} [#${claim?.id_siniestro}]`}
        messages={chatData}
        selfId={$user?.shortName}
        placeholder="Escriba aquí y presione Enter para enviar."
        disabledMsg="Ya no puedes responder a esta conversación"
        bind:disabled={closed}
        bind:showContext
        on:message={pushMessage}
        showFrom
    >
        <svelte:fragment slot="context">
            <span class="context">
                <Typography color style="margin: 3px 0 5px 0" type="h4"
                    >Detalles del reclamo</Typography
                >
                <p class="sdf"><i>Asunto:</i><span>{claim.asunto}</span></p>
                <p class="sdf">
                    <i>Identificador:</i><span>{claim.id_reclamo}</span>
                </p>
                <p class="sdf">
                    <i>Siniestro:</i><span>{claim.id_siniestro}</span>
                </p>
                    <p class="sdf">
                        <i>Patente:</i><span>{claim.patente}</span>
                    </p>
                <p class="sdf">
                    <i>Motivo de Reclamo:</i><span
                        >{($dictionaries.lic_motivos_reclamos || []).find(
                            (x) => x.value == claim.tipo_reclamo
                        )?.label || '(sin especificar)'}</span
                    >
                </p>
                <p class="sdf" title={open_date.toLocaleString()}>
                    <i>Abierto:</i><span>{getRelTime(open_date)}</span>
                </p>
                <!-- <p class="sdf lang" style="margin: 10px 0px 0px 5px;"><i>Descripcion:</i><span>{claim.descripcion}</span></p> -->
                {#if claim.items?.length > 0}
                    <p class="sdf lang">
                        <i>Items relacionados:</i>
                        <span>
                            <table>
                                <thead>
                                    <tr>
                                        <td>Categoria</td>
                                        <td>Desc.</td>
                                        <td>Precio.</td>
                                        <td>Cant.</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {#each claim.items as item}
                                        <tr>
                                            <td>{item.categoria}</td>
                                            <td>{item.descripcion}</td>
                                            <td>{currencyFormatter({n: item.precio_unitario, type: 'ARS', lang: 'es-AR'})}</td>
                                            <td>{item.cantidad}</td>
                                        </tr>
                                    {/each}
                                </tbody>
                            </table>
                        </span>
                    </p>
                {/if}
                {#if closed}
                    <p class="sdf" title={close_date.toLocaleString()}>
                        <i>Cerrado:</i>
                        <span>{getRelTime(close_date)}</span>
                    </p>
                    <!-- {:else}
                    <Button size="medium" bind:disabled={waiting} style="width: 50%" on:click={closeClaim}>Cerrar reclamo</Button> -->
                {/if}
            </span>
        </svelte:fragment>
        <svelte:fragment slot="beforeTitle">
            {#if back}
                <span on:click={onBack} style="cursor: pointer;">
                    <ChevronBackOutline color="white" />
                </span>
            {/if}
        </svelte:fragment>
    </ChatWidget>
</div>

<style>
    .context {
        display: flex;
        width: 100%;
        height: 100%;
        flex-direction: column;
    }
    .sdf {
        margin: 5px 0 5px 5px;
        min-height: 35px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        /* background-color: rgba(200, 0, 0, 0.05); */
        font-weight: 700;
    }
    .sdf i {
        font-style: inherit;
    }
    .sdf span {
        font-weight: 400;
        color: grey;
    }
    .lang {
        flex-direction: column;
        align-items: flex-start;
        /* gap: 0px; */
        justify-content: flex-start;
    }
    table {
        width: 100%;
        border: 0;
        table-layout: fixed;
        overflow-wrap: break-word;
        text-indent: 8px;
    }
    table thead {
        font-weight: 700;
        background-color: var(--color-brand-primary-01);
        color: white;
    }
    table tbody tr:nth-child(odd) {
        background-color: rgba(0, 0, 0, 0.05);
    }
</style>
